import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fee94d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view w-100 h-100" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "alerts" }
const _hoisted_4 = { style: {"white-space":"pre-wrap"} }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "alert-date" }
const _hoisted_7 = { class: "link mx-auto" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-f icon-info mx-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_view_header = _resolveComponent("view-header")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_view_header, {
      flip: false,
      text: _ctx.t('cashier.system-alerts.title')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "alert",
            key: msg.id
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(msg.text), 1),
            _createElementVNode("span", {
              class: "icon-f icon-delete-cross fs-20",
              onClick: ($event: any) => (_ctx.removeMessage(msg.id))
            }, null, 8, _hoisted_5),
            _createElementVNode("span", _hoisted_6, _toDisplayString(msg.date), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createTextVNode(" " + _toDisplayString(_ctx.t("cashier.system-alerts.feedback")), 1)
      ])
    ])
  ]))
}